import { branding } from '@guridosdrones/shared';

/**
 * Generates a WhatsApp link with a pre-filled, URL-encoded message.
 * @param message The message to pre-fill in the WhatsApp chat.
 * @returns A formatted WhatsApp URL.
 */
export function getWhatsAppLink(message: string): string {
  const phone = branding.contact.phone.replace(/\D/g, ''); // Extract only numbers
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phone}?text=${encodedMessage}`;
}

export const WHATSAPP_MESSAGES = {
  HEADER: 'Olá! Vi o site do Guri dos Drones e quero saber mais sobre o curso de piloto.',
  TIMELINE:
    'Olá, Eduardo! Completei a trilha no site e estou pronto para iniciar minha jornada no curso. Como faço a matrícula?',
  MAPPING:
    'Oi Guri! Tenho interesse específico no curso de Mapeamento Aéreo 3D. Pode me passar os detalhes?',
  FAQ: 'Olá! Estava lendo o FAQ no site e ainda tenho uma dúvida sobre o curso. Pode me ajudar?',
};
